import React from 'react';

import ProductTile from './ProductTile';
import config from '../../constants';

const productPlatformList = ['CS', 'PDP', 'DAC', 'GenAI', 'Corporate'];

const productInfo = {
  WC: {
    bgImage: 'Tile-worley-consulting.png',
    productShortName: 'Wc',
    logo: 'Tile-worley-consulting-logo.svg',
    title: 'Worley consulting',
    description: 'Explore all applications developed by Worley Consulting',
    iconClassName: 'bg-lush-green-50 text-lush-green-80',
  },
  PD: {
    bgImage: 'Tile-project-delivery.png',
    productShortName: 'Pd',
    logo: 'Tile-project-delivery-logo.svg',
    title: 'Product delivery',
    description: 'Your go-to hub for seamless project execution',
    iconClassName: 'bg-sky-mist-30 text-sky-mist-80',
  },
  DAC: {
    bgImage: 'Tile-dac-artemis.png',
    productShortName: 'Da',
    logo: 'Tile-dac-artemis-logo.svg',
    title: 'DAC artemis',
    description: 'Access DAC Artemis',
    iconClassName: 'bg-scorched-rose-50 text-scorched-rose-100',
  },
  GenAI: {
    bgImage: 'Tile-gen-ai-applications.png',
    productShortName: 'Gi',
    logo: 'Tile-gen-ai-applications-logo.svg',
    title: 'Generative AI',
    description: 'AI-powered tools designed to simplify everyday tasks',
    iconClassName: 'bg-gold-50 text-gold-90',
  },
  Corporate: {
    bgImage: 'Tile-corporative-applications.png',
    productShortName: 'Ca',
    logo: 'Tile-corporate-applications-logo.svg',
    title: 'Corporate applications',
    description: 'Essential apps for business operations',
    iconClassName: 'bg-blue-40 text-blue-80',
  },
};

export default function LandingPage() {
  const profileData = JSON.parse(sessionStorage.getItem('profileData'));
  const { FirstName } = profileData;
  return (
    <div>
      <div className="home-page">
        <div
          className=" bg-deep-sea-60 bg-right-bottom bg-no-repeat px-10 py-4"
          style={{ backgroundImage: "url('/assets/Topographic-lines.png')", backgroundSize: '70%' }}
        >
          <h1 className="text-3xl text-sky-mist-60">Hello {FirstName}</h1>
          <h2 className="mt-5 text-2xl text-white">
            Welcome to
            <span className="font-bold text-scorched-rose-60"> Worley Digital Platform</span>
          </h2>
          <p className="font-light text-white">The central hub for all our applications.</p>
          <div className="mt-5 max-w-[530px]">
            <p className="text-sm font-normal text-white">
              Explore our tools, organized by category, and find the right solutions to enhance your
              work. Click on a category to discover the applications available across Worley
            </p>
          </div>
        </div>
      </div>
      <div className="min-h-[538px] px-10 py-6">
        <ul className="flex flex-wrap gap-8">
          {config.productList.map((p) => {
            //const productDetails = profileData.Applications.find((app) => app.Name === p);
            return (
              <li key={p.name}>
                <a href={`${p?.url}`} target="_blank" rel="noreferrer">
                  <ProductTile
                    bgImage={productInfo[p.name].bgImage}
                    productShortName={productInfo[p.name].productShortName}
                    logo={productInfo[p.name].logo}
                    title={productInfo[p.name].title}
                    description={productInfo[p.name].description}
                    iconClassName={productInfo[p.name].iconClassName}
                  />
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
